import React from "react";
import "../css/HomePage.css";

const Card = ({ title, body, imgSrc }) => (
  <article className="mtg-card">
    <h3>{title}</h3>
    <p>{body}</p>
    <img className="mtg-card-img" src={imgSrc} alt="" loading="lazy" />
  </article>
);

export default function ExploreAppSection() {
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 767px)").matches;

  return (
    <section className="mtg-explore">
      <div className="mtg-explore-head">
        <h2>Explore the App</h2>
      </div>

      {!isMobile && (
        <>
          <img
            className="mtg-explore-blob-1"
            src="https://mentortogether.org/wp-content/uploads/2024/12/bg10.svg"
            alt=""
            aria-hidden="true"
            role="presentation"
            loading="lazy"
            decoding="async"
          />
          <img
            className="mtg-explore-blob-2"
            src="https://mentortogether.org/wp-content/uploads/2024/12/bg9.svg"
            alt=""
            aria-hidden="true"
            role="presentation"
            loading="lazy"
            decoding="async"
          />
        </>
      )}

      <div className="mtg-explore-grid">
        <div className="mtg-col-left">
          <Card
            title="Build your profile"
            body="We do a basic background survey for both mentors and mentees to verify them and curate strong matches!"
            imgSrc="https://mentortogether.org/wp-content/uploads/2025/02/sing-up-2.png"
          />
        </div>
        <div className="mtg-col-right">
          <Card
            title="Learning Hub"
            body="Curated modules and resources are provided to mentors and mentees to prepare themselves for their Mentor To Go sessions before diving in."
            imgSrc="https://mentortogether.org/wp-content/uploads/2025/02/LH-sessions-e1753937759215.png"
          />
        </div>
        <div className="mtg-col-left">
          <Card
            title="Matching Algorithm"
            body="Based on mentees career interests and preferences, we match them with mentors who fit the bill."
            imgSrc="https://mentortogether.org/wp-content/uploads/2025/02/matching-e1753937682688.png"
          />
        </div>
        <div className="mtg-col-right">
          <Card
            title="Designed to enhance learning"
            body="An evidence based curriculum with activities, quizzes, and live discussions to grow technical skills and soft skills."
            imgSrc="https://mentortogether.org/wp-content/uploads/2025/02/mentorship-e1753937654549.png"
          />
        </div>
      </div>
    </section>
  );
}
